import { HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

export interface FooterProps extends HTMLAttributes<HTMLElement> {
  links?: FooterLink[];
  showCopyright?: boolean;
  copyrightText?: string;
}

const defaultLinks: FooterLink[] = [
  { label: 'Documentation', href: '/docs', external: true },
  { label: 'Support', href: '/support', external: true },
  { label: 'Terms of Service', href: '/terms', external: true },
  { label: 'Privacy Policy', href: '/privacy', external: true },
];

export const Footer = ({
  links = defaultLinks,
  showCopyright = true,
  copyrightText = `© ${new Date().getFullYear()} Ketrics. All rights reserved.`,
  className,
  ...props
}: FooterProps) => {
  return (
    <footer
      className={clsx(
        'border-t mt-auto',
        className
      )}
      style={{ backgroundColor: 'var(--color-bg-raised)', borderColor: 'var(--color-border)' }}
      {...props}
    >
      <div className="px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Copyright */}
          {showCopyright && (
            <p className="text-sm text-center sm:text-left" style={{ color: 'var(--color-text-muted)' }}>
              {copyrightText}
            </p>
          )}

          {/* Links */}
          {links && links.length > 0 && (
            <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
              {links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm transition-colors hover:text-primary-500"
                  style={{ color: 'var(--color-text-muted)' }}
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener noreferrer' : undefined}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          )}
        </div>
      </div>
    </footer>
  );
};
